import React, { useCallback } from 'react'
import { connect } from 'react-redux'
import { accountAccessShowLogin } from 'actions/UiActions'
import TextButton from 'components/Luxkit/Button/TextButton'
import { hasAccountNotification } from 'selectors/accountSelectors'
import FormatCurrency from 'components/Common/FormatCurrency'
import AvatarCircle from 'components/Common/AvatarCircle/AvatarCircle'
import Caption from 'components/Luxkit/Typography/Caption'
import { isFlightsCredit } from 'selectors/flightsSelectors'
import TripGuard from 'tripPlanner/components/TripGuard/TripGuard'
import NavigationHeaderTripsMenu from './NavigationHeaderTripsMenu'
import Group from 'components/utils/Group'
import BusinessTravellerAccountButtonMenu from 'businessTraveller/components/business-account/BusinessTravellerAccountButtonMenu'
import { useAppDispatch } from 'hooks/reduxHooks'
import config from 'constants/config'
import { useRestoreCartState } from 'checkout/hooks/useRestoreCartState'
import LuxuryPlusAccountButton from 'loyalty/components/LuxuryPlusAccountButton'
import { isActiveLuxuryPlusMember } from 'loyalty/selectors/featureToggle'

interface Props {
  isLoggedIn: boolean;
  className?: string;
  hasNotification: boolean;
  firstName?: string;
  lastName?: string;
  balance: number;
  isActiveLuxuryPlusMember: boolean;
}

function NavigationHeader(props: Props) {
  const {
    isLoggedIn,
    className,
    hasNotification,
    firstName,
    lastName,
    balance,
    isActiveLuxuryPlusMember,
  } = props
  const appDispatch = useAppDispatch()
  useRestoreCartState()

  const openLogin = useCallback(() => {
    appDispatch(accountAccessShowLogin())
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Group direction="horizontal" gap={16} className={className}>
      <TripGuard>
        <NavigationHeaderTripsMenu/>
      </TripGuard>

      {isLoggedIn && config.businessTraveller.currentAccountMode === 'business' && <BusinessTravellerAccountButtonMenu />}

      {isLoggedIn && config.businessTraveller.currentAccountMode !== 'business' && (
        <>
          {isActiveLuxuryPlusMember &&
            <LuxuryPlusAccountButton
              firstName={firstName}
              lastName={lastName}
              hasNotification={hasNotification}
              balance={balance}
            />}
          {!isActiveLuxuryPlusMember &&
            <TextButton
              kind="tertiary"
              to="/account"
              variant="dark"
              aria-label="Account"
              startIcon={ <AvatarCircle
                size="small"
                firstName={firstName}
                lastName={lastName}
                hasNotification={hasNotification}
                nonInteractable
              />}
            >
              <div>
                Account
                {balance > 0 &&
                  <Caption variant="medium">
                    <FormatCurrency value={balance} format="dynamicDollar" />
                  </Caption>
              }
              </div>
            </TextButton>}
        </>
      )}

      {!isLoggedIn && (
        <TextButton
          kind="primary"
          onClick={openLogin}
          role="menuitem"
          name="signup"
        >
          Sign in
        </TextButton>
      )}
    </Group>
  )
}

function mapStateToProps(state: App.State) {
  return {
    hasNotification: hasAccountNotification(state),
    balance: state.auth.account.balance,
    isFlightsCredit: isFlightsCredit(state),
    firstName: state.auth.account.givenName,
    lastName: state.auth.account.surname,
    isActiveLuxuryPlusMember: isActiveLuxuryPlusMember(state),
  }
}

export default connect(mapStateToProps)(NavigationHeader)
